import React, { useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FaFileInvoiceDollar } from 'react-icons/fa';
import { AuthContext } from '../authProvider.mjs';
import PageShell from './PageShell.mjs';
import { CARD_SURFACE, CardIcon } from './HomeCard.mjs';
import { claimsOpenFor, regionName } from '../utils/claimRegions.mjs';

/**
 * Gate for the pages that START a claim, in a region claims are not open to
 * yet (utils/claimRegions.mjs).
 *
 * The home page already says so when a claim type is picked; this covers the
 * same forms reached any other way - a bookmark, a typed URL, the admin's
 * "file for someone" card. It explains instead of handing over a form the
 * server would refuse on save.
 *
 * allowExisting lets a route that also OPENS an existing claim (/claim/expense/
 * :claimId) through when it has an id: reading what is already filed is not
 * filing anything.
 */
const ClaimsOpenRequired = ({ children, allowExisting = false }) => {
  const { user } = useContext(AuthContext);
  const { claimId } = useParams();
  const navigate = useNavigate();

  if (claimsOpenFor(user) || (allowExisting && claimId)) return children;

  return (
    <PageShell title="Coming Soon" width="3xl" centerContent>
      <div className={`${CARD_SURFACE} p-6 sm:p-8 flex flex-col items-center text-center`}>
        <CardIcon icon={FaFileInvoiceDollar} />
        <h2 className="text-lg font-bold text-gray-800 mb-2">
          Claims are coming to {regionName(user?.region)} soon
        </h2>
        <p className="text-sm text-gray-600 mb-6 max-w-md">
          For now, claims can only be filed in East Africa. Everything else - your
          dashboard and anything you have already filed - works as usual.
        </p>
        <button
          type="button"
          onClick={() => navigate('/')}
          className="min-h-[44px] px-5 py-2 bg-stanford-red text-white rounded-lg font-medium hover:bg-stanford-light-red transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-stanford-red"
        >
          Back to home
        </button>
      </div>
    </PageShell>
  );
};

export default ClaimsOpenRequired;
